// @ts-nocheck
import {
  FETCH_CAMPAIGNS_FULFILLED,
  FETCH_CAMPAIGNS_REJECTED,
  FETCH_CAMPAIGN_FULFILLED,
  FETCH_CAMPAIGN_PRODUCTS_FULFILLED,
  FETCH_CAMPAIGN_PRODUCTS_REJECTED,
  FETCH_CAMPAIGN_REJECTED,
  FETCH_CAMPAIGN_SERIES_FULFILLED,
  FETCH_CAMPAIGN_SERIES_REJECTED,
  UPDATE_CAMPAIGN_FULFILLED,
  UPDATE_CURRENT_PAGE_FULFILLED,
  FETCH_CAMPAIGN_SERIES_SEGMENTS_FULFILLED,
  FETCH_CAMPAIGN_SERIES_SEGMENTS_REJECTED,
} from './campaignActionTypes';

const initialState = {
  campaigns: null,
  campaignDetails: null,
  campaignSeries: null,
  products: null,
  page: 1,
  seriesSegments: [],
};

export default function campaignReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CAMPAIGNS_FULFILLED:
      return {
        ...state,
        campaigns: action.payload,
      };
    case FETCH_CAMPAIGNS_REJECTED:
      return {
        ...state,
        campaigns: null,
      };
    case FETCH_CAMPAIGN_FULFILLED:
      return {
        ...state,
        campaignDetails: action.payload,
      };
    case FETCH_CAMPAIGN_REJECTED:
      return {
        ...state,
        campaignDetails: null,
      };
    case FETCH_CAMPAIGN_SERIES_FULFILLED:
      return {
        ...state,
        campaignSeries: action.payload,
      };
    case FETCH_CAMPAIGN_SERIES_REJECTED:
      return {
        ...state,
        campaignSeries: null,
      };
    case FETCH_CAMPAIGN_PRODUCTS_FULFILLED:
      return {
        ...state,
        products: action.payload,
      };
    case UPDATE_CURRENT_PAGE_FULFILLED:
      return {
        ...state,
        page: action.payload,
      };
    case FETCH_CAMPAIGN_PRODUCTS_REJECTED:
      return {
        ...state,
        products: null,
      };
    case UPDATE_CAMPAIGN_FULFILLED:
      return {
        ...state,
        campaignDetails: action.payload,
      };
    case FETCH_CAMPAIGN_SERIES_SEGMENTS_FULFILLED:
      return {
        ...state,
        seriesSegments: action.payload,
      };
    case FETCH_CAMPAIGN_SERIES_SEGMENTS_REJECTED:
      return {
        ...state,
        seriesSegments: [],
      };
    default:
      return state;
  }
}
